import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-flag",
  "use": "icon-cl-flag-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-flag\"><path d=\"M2 2v12h1.333V9.333h4.922l.667 1.334H14V3.333H9.745L9.078 2H2Zm1.333 1.333h4.922l.667 1.334h3.745v4.666H9.745L9.078 8H3.333V3.333Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol